import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { reportWebVitals } from "./reportWebVitals";
import { Init } from "./Init";

declare global {
  interface Window {
    // Set only by the build's prerender script (prerender/prerender.mjs),
    // before the app loads.
    breadPrerender?: {
      renderToString?: () => Promise<string>;
    };
  }
}

const container = document.getElementById("root") as HTMLElement;

const app = (
  <React.StrictMode>
    <Init></Init>
  </React.StrictMode>
);

// Marketing pages are prerendered to static HTML at build time, so the root may
// already hold server-rendered markup that React should adopt rather than
// discard. On a normal client-only boot the container is empty and we mount as
// before. public/index.html empties it for signed-in visitors on "/".
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// The prerender saves React's server rendering of the page rather than the live
// DOM. Hydration needs markup in exactly the shape the server renderer writes;
// a DOM snapshot differs from it, most visibly by merging adjacent text nodes,
// and any difference makes React discard the page and draw it again, replaying
// its load-in. Loaded on demand, so visitors never download the server renderer.
if (window.breadPrerender !== undefined) {
  window.breadPrerender.renderToString = async () => {
    const server = await import("react-dom/server");
    return server.renderToString(app);
  };
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
